import { render, staticRenderFns } from "./GraphDetail56.vue?vue&type=template&id=2fb37dac&scoped=true&"
import script from "./GraphDetail56.vue?vue&type=script&lang=js&"
export * from "./GraphDetail56.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb37dac",
  null
  
)

export default component.exports